<div fxLayout="row" fxLayoutAlign="space-between center">
  <div class="field-container" fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center">
    <div class="attribute-name">
      <b>{{ flatAttribute?.name }}</b>
    </div>

    <div
      *ngIf="flatAttribute?.hasAttributes || flatAttribute?.hasComplexAttributeValues"
      fxFlex
      class="attribute-values"
    >
      <div *ngIf="!flatAttribute.isComplexField">
        <ng-container *ngIf="flatAttribute?.isStarRating">
          <app-star-rating-attribute [selectedStarRating]="firstElementValueListItem"></app-star-rating-attribute>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isLongAnswer">
          <div
            class="attribute-long-answer"
            *ngFor="let attribute of flatAttribute?.attributes"
            [innerHTML]="attribute.value | safeHtml"
          ></div>
        </ng-container>
        <ng-container
          *ngIf="
            !flatAttribute?.isStarRating &&
            !flatAttribute?.isLongAnswer &&
            !flatAttribute?.isDocument &&
            !flatAttribute?.isEncryptedField
          "
        >
          <span class="displayValues" *ngFor="let value of flatAttribute?.attributes">{{
            formatDisplayValue(value)
          }}</span>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isEncryptedField">
          <span class="displayValues" *ngFor="let value of flatAttribute?.attributes">***</span>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isDocument">
          <div *ngFor="let attribute of flatAttribute?.attributes" class="document-list">
            <app-custom-document-viewer
              *ngIf="flatAttribute?.hasAttributes"
              [documentAttribute]="attribute"
            ></app-custom-document-viewer>
          </div>
        </ng-container>
      </div>
      <div *ngIf="flatAttribute.isComplexField">
        <div *ngFor="let complexAttributeValue of flatAttribute?.complexAttributeValues" class="attribute-value">
          <app-complex-field-viewer [complexAttributeValue]="complexAttributeValue"></app-complex-field-viewer>
        </div>
      </div>
    </div>
    <div
      *ngIf="!flatAttribute?.hasAttributes && !flatAttribute?.hasComplexAttributeValues"
      fxFlex
      fxLayout="row"
      class="add-attribute-values"
    >
      <button
        mat-button
        aria-label="Click to Add"
        (click)="openEditAttributeModal()"
        class="add-attribute-values-button"
      >
        Click to Add
      </button>
    </div>
  </div>
  <div *ngIf="flatAttribute?.hasAttributes || flatAttribute?.hasComplexAttributeValues" style="width: 40px">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Custom Fields actions">
      <mat-icon>more_vert</mat-icon>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openEditAttributeModal()">Edit Field</button>
        <button mat-menu-item (click)="onClearField()" *ngIf="!flatAttribute?.isDocument">Clear Field</button>
      </mat-menu>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
